import memoize from 'lodash/memoize';

export default async function fetchJSON(
    url: RequestInfo,
    settings?: RequestInit
) {
    const response = await fetch(url, {
        credentials: 'same-origin',
        ...settings,
    });
    return response.json();
}

fetchJSON.memoized = memoize(fetchJSON, (url, settings) =>
    JSON.stringify([url, settings])
);
